import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'cmt_group',
} as IModuleProps;
